"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberInnerValue = exports.NumberInner = void 0;
var _mui = require("@ori-ui/mui");
const NumberInner = exports.NumberInner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  overflow: 'hidden',
  flexFlow: 'row wrap',
  gap: theme.spacing(1),
  width: '100%'
}));
const NumberInnerValue = exports.NumberInnerValue = (0, _mui.styled)(_mui.Typography)(() => ({
  display: 'flex',
  whiteSpace: 'nowrap'
}));
